import { JwtUser } from "@navigate/common/src/types/user.types"

import React, { createContext, useContext, useEffect, useState } from "react"
import { getUserFromLocalStorage } from "./auth.utils"

type AuthInitialState = {
  user?: JwtUser
}

export const AuthInitialState = {
  user: undefined,
}

export const AuthContext = createContext<AuthInitialState>({} as AuthInitialState)

export const useAuth = () => useContext(AuthContext)

export const AuthProvider = ({ children }: any) => {
  const [user, setUser] = useState(getUserFromLocalStorage() || AuthInitialState.user)

  function storageEventHandler() {
    setUser(getUserFromLocalStorage())
  }

  useEffect(() => {
    window.addEventListener("storage", storageEventHandler, false)
    return () => window.removeEventListener("storage", storageEventHandler, false)
  }, [])

  return (
    <AuthContext.Provider
      value={{
        user,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
